import { ICircleObject } from "../../../../../domain/editableFormat/objects";
import { ICircleObjectBean } from "../../beans/objects";
import { TexturedShapeDrawableObjectTranslator } from "./base";

export class CircleObjectTranslator extends TexturedShapeDrawableObjectTranslator<ICircleObject, ICircleObjectBean> {}
